<template>
    <div style="">    
        
        <!-- RADIOBUTTON-->
        <div v-if="parameter.field_type === 'radiobutton'">    
            <div class="d-flex align-items-start flex-column">

                <h5>{{parameter.attribute.name}}</h5>
                <button @click='clean'>Limpiar</button>

                <div v-for="attributeValue in parameter.values"
                        :key="attributeValue.id"> 
                    <div v-if="attributeValue.childs.count > 0">                
                        <p>{{attributeValue.name}}</p>
                    </div>
                    <div v-else>
                        <input type = "radio" 
                            :id = "attributeValue.id" 
                            :name="parameter.attribute.id" 
                            :value="JSON.stringify(attributeValue)"
                            :checked='value !== null && attributeValue.id == value.id ? true : false'
                            :disabled='! attributeValue.status'                            
                            @change="emitChange">                                                   
                        <label :for ="attributeValue.id" style="background-color:white" >
                            {{ attributeValue.name}}
                        </label>  
                    </div>
                </div>
            </div>
        </div>

        <!-- DROPDOWN-->
        <div v-if="parameter.field_type === 'dropdown'">

            <h5>{{parameter.attribute.name}}</h5>

            <select :value='value'
                @change="emitChange">
                <option :value='null'>(Seleccione un elemento)</option>
                <option v-for="attributeValue in parameter.values" 
                        :key="attributeValue.id" 
                        :value="JSON.stringify(attributeValue)"
                        :disabled='! attributeValue.status'     
                        :selected="attributeValue.id === value.id">
                    {{attributeValue.name}}
                </option>
            </select>

        </div> 
  </div>
</template>

<script>
import { app } from '../application.js'
import attribute from '../models/attribute.js'
import parameter from '../models/parameter.js'

export default {
    name: 'selectAttributeValue',
    props: {
        parameter: new parameter(),
        value: null
    },  

    data () {
        return {
                _selectedValue: null
            }
    },

    computed: {
        selectedValue: {
            get: function(){
                return this.$data._selectedValue;
            },
            set: function(newValue){
                this.$data._selectedValue = newValue;
            }
        }
    },

    components:{
        
    },

    methods: {
        emitChange(e) {
            this.selectedValue = JSON.parse(e.target.value);
            this.$emit('update:value', this.selectedValue );
        },
        clean(){
            this.selectedValue = '';
            this.$emit('update:value', '' );
        }
  }  
}
</script>

<style lang="scss">

</style>
